import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  dismiss(event) {
    let uuid = event.currentTarget.dataset.modalUuid
    document.getElementById(`modal-${uuid}`).classList.add('hidden')
    document.getElementById('VC-MODAL-BG').classList.add('hidden')
    document.dispatchEvent(new Event('modal-close'))
  }

  show(event) {
    let uuid = event.currentTarget.dataset.modalUuid
    document.getElementById('VC-MODAL-BG').classList.remove('hidden')
    document.getElementById(`modal-${uuid}`).classList.remove('hidden')
  }
}
